class LocMarkupBase {
  static get selectors() {
    const CoverContainer = '.locview-cover';
    return {
      CoverContainer,
      CoverImage: `${CoverContainer} .locview-cover-img`,
    };
  }

  constructor(loc) {
    this.loc = loc;
  }

  get coverMarkup() {
    return `
      <div class='locview-cover'>
        <div class='aspect-ratio-div'>
          <img class='locview-cover-img aspect-ratio-div-child'
               src='/images/blueberries.jpg'>
          ${this.coverButtonsMarkup}
        </div>
      </div>
    `;
  }

  get coverButtonsMarkup() {
    return '';
  }

  get allFieldNames() {
    return this.loc.constructor.FieldsSortingList;
  }

  loc;
}

export { LocMarkupBase };
